<template>
  <div>
    <Hospital :selectedStatuses="statuses"></Hospital>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const Hospital = defineAsyncComponent(() =>
  import("@/components/hospitals/AllHospitals")
);
export default {
  components: {
    Hospital,
  },
  data() {
    return {
      statuses: "ACTIVE",
    };
  },
};
</script>
